const React = require("react");
const T = require("prop-types");
const { default: Dialog } = require("material-ui/Dialog");
const { default: RaisedButton } = require("material-ui/RaisedButton");
const { default: FlatButton } = require("material-ui/FlatButton");
const Classes = require("./styles.scss");

module.exports = class DeleteConfirmDialog extends React.PureComponent {
    static propTypes = {
        dialogOpen: T.bool.isRequired,
        dialogClose: T.func.isRequired,
        onDelete: T.func.isRequired,
        croquis: T.object
    };

    render() {
        const { dialogOpen, onDelete, dialogClose, croquis } = this.props;

        const actions = [
            <div>
                <FlatButton
                    label="Cancel"
                    onClick={dialogClose}
                    className={Classes.modalButton}
                />
                <RaisedButton
                    primary
                    label="Delete"
                    onClick={() => onDelete(croquis.id)}
                    className={`${Classes.modalButton} ${Classes.modalButtonSubmit}`}
                />
            </div>
        ];

        const title = croquis ? croquis.title : "";

        return (
            <Dialog
                title={`Do you really want to delete your Body Model "${title}"?`}
                actions={actions}
                open={dialogOpen}
                modal={false}
                onRequestClose={dialogClose}
                autoScrollBodyContent
                paperClassName={Classes.modal}
            >
                <p>Warning: deleting a Body Model cannot be undone!</p>
            </Dialog>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Dialog/DeleteConfirmDialog.js